// web-common/src/api.js — the ONE /v1 transport (D1-DESIGN §2.1). fetch in, a CLASSIFIED
// result out (web-common/src/errors.js) — screens never see raw HTTP. Both SPAs make one
// instance at boot and pass it down via context.

import { classify, classifyNetworkError } from './errors.js';

// makeApi({ baseUrl, getToken, onMaintenance }) — getToken: async () => the Firebase ID token
// (or the dev token, §10 rig). baseUrl: '' in dev (the Vite proxy serves /v1), the Functions URL
// in prod. onMaintenance(message): optional — called whenever ANY reply is a 503 {maintenance}
// (MAINT-MODE §8b), the ONE centralized hook that flips the app to the maintenance page.
export function makeApi({ baseUrl = '', getToken, onMaintenance = null }) {
  async function call(method, path, body = null, { idempotencyKey = null } = {}) {
    const headers = { Accept: 'application/json' };
    const token = getToken ? await getToken() : null;
    if (token) headers.Authorization = 'Bearer ' + token;
    if (body != null) headers['Content-Type'] = 'application/json';
    if (idempotencyKey) headers['Idempotency-Key'] = idempotencyKey;
    let res;
    try {
      res = await fetch(`${baseUrl}/v1/${path}`, { method, headers, body: body != null ? JSON.stringify(body) : undefined });
    } catch (e) {
      return classifyNetworkError(e);
    }
    let parsed = null;
    try { parsed = await res.json(); } catch { /* non-JSON body — classify on status alone */ }
    // MAINT-MODE §8b: a maintenance 503 from any call flips the app to the maintenance page —
    // surfaced through one hook so no screen has to handle it.
    if (onMaintenance && res.status === 503 && parsed && parsed.maintenance) {
      try { onMaintenance(typeof parsed.message === 'string' ? parsed.message : ''); } catch { /* never let the hook break the call */ }
    }
    return classify(res.status, parsed);
  }
  return {
    get: (path) => call('GET', path),
    post: (path, body, opts) => call('POST', path, body || {}, opts),
    put: (path, body) => call('PUT', path, body || {}),
    patch: (path, body) => call('PATCH', path, body || {}), // drafts (CREATE-1 §5.1)
    del: (path) => call('DELETE', path),                    // brands archive (CREATE-1 §6)
  };
}
